import Spinner from 'components/Spinner';

export default function PageSpinner() {
  return (
    <div className="flex justify-center pt-12">
      <Spinner />
    </div>
  );
}
